import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLiveops } from '@/modules/liveops/item/model/mixins';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { liveopsPointService } from '@/services/liveops';

export function useLiveopsEdit() {
    const router = useAppRouter();

    const { model, v$, fetch } = useLiveops();

    const actions = {
        update: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                liveopsPointService.item.update(
                    model.id,
                    model.name,
                    model.rewardType,
                    model.type,
                    model.betCosts,
                    model.startTime.getTime(),
                    model.closeTime.getTime(),
                    model.endTime.getTime(),
                    model.imageFile,
                    model.iconFile
                ),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_LIVEOPS.ITEM.DETAIL(model.rewardType), params: { id: model.id } })
        })
    };

    return { model, v$, fetch, actions };
}
